import axios from 'axios'
import { config } from '../shared/app.config'

const RESOURCE_NAME = '/productcategories'

export default {
  edit(id, category) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/${id}`, category)
  },
  create(category) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}`, category)
  },
  getCategory(id) {
    return axios.get(`${config.webApiBase + RESOURCE_NAME}/${id}`)
  },
  delete(id) {
    return axios.delete(`${config.webApiBase + RESOURCE_NAME}/${id}`)
  },
  getList(page, per_page, search = '', parent, only_children) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/list`, {
      page,
      per_page,
      search,
      parent,
      only_children
    })
  },
  getListCreateProject(departments) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/list/createProject`, {
      departments,
    })
  },
}
